import { Box, Button, Typography } from '@mui/material';
import HourglassEmptyIcon from '@mui/icons-material/HourglassEmpty';

interface UserInHumanReviewScreenProps {
  // Llamado cuando el usuario cierra el widget tras leer el mensaje bloqueante
  onDismiss?: () => void;
}

// Pantalla D-7: el usuario ya tiene un proceso en revisión humana activo en kyc_users.
// No puede iniciar uno nuevo hasta que el equipo de validación resuelva el proceso existente.
// Diferencia con HumanReviewScreen: esta pantalla aparece al INICIAR la sesión (CHECKING_STATUS
// detectó human_review); HumanReviewScreen aparece al TERMINAR el flujo actual (liveness completo).
export function UserInHumanReviewScreen({ onDismiss }: UserInHumanReviewScreenProps) {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        py: 6,
        gap: 2,
        textAlign: 'center',
      }}
    >
      <HourglassEmptyIcon sx={{ fontSize: 72, color: 'warning.main' }} />

      <Typography variant="h5" fontWeight={700}>
        Verificación en proceso
      </Typography>

      <Typography variant="body1" color="text.secondary" sx={{ maxWidth: 420 }}>
        Tu proceso de verificación de identidad está siendo revisado por nuestro equipo
        de seguridad. No puedes iniciar una nueva verificación hasta que se resuelva el
        proceso actual.
      </Typography>

      <Typography variant="body2" color="text.disabled" sx={{ maxWidth: 380 }}>
        Recibirás una notificación con el resultado en un plazo de 24 a 48 horas hábiles.
        No es necesario que realices ninguna acción adicional.
      </Typography>

      {onDismiss && (
        <Button
          variant="contained"
          color="warning"
          onClick={onDismiss}
          sx={{ mt: 3 }}
        >
          Entendido
        </Button>
      )}
    </Box>
  );
}
